import {
  FUNDED_TIMESTAMP_FILTER,
  TRANSACTION_DATE_FILTER,
} from "@/components/transactionSearchPage/TransactionSearchPage.state";
import { toAmountQueryParams } from "@/components/transactionSearchPage/amountFilter";

/**
 * multiSelectParam
 *
 * Backwards-compatible NLS transaction search multi-select serialization.
 * @param {string} singularKey - The key for a single selection.
 * @param {string} arrayKey - The key for an array of selections.
 * @param {string} value - The value to serialize.
 * @returns {object} - The serialized value.
 */
const multiSelectParam = (singularKey, arrayKey, value) => {
  const values = Array.isArray(value) ? value.filter(Boolean) : value ? [value] : [];
  if (values.length === 0) return {};
  if (values.length === 1) return { [singularKey]: values[0] };
  return { [arrayKey]: values };
};

export const transactionSearch = ({
  agencies,
  amount,
  client,
  page,
  paymentStatus,
  startDate,
  endDate,
  dateFilter,
  cardholderName,
  bankAccountHolderName,
  bankLastFour,
  cardLastFour,
  paymentChannel,
  paymentSource,
  paymentMethod,
  paymentMode,
  resultsPerPage,
  serviceType,
  transactionId,
  accountNumber,
  token,
}) => ({
  HTTPMethod: "get",
  path: `/payments`,
  queryParams: {
    agencies,
    // Decompose amount criteria (may contain operators or ranges) into backend params. Falls back to bare `amount=` for exact match.
    ...toAmountQueryParams(amount),
    client,
    page,
    ...multiSelectParam("status", "statuses", paymentStatus),
    beginning_time:
      startDate && dateFilter === TRANSACTION_DATE_FILTER ? startDate : undefined,
    ending_time:
      endDate && dateFilter === TRANSACTION_DATE_FILTER ? endDate : undefined,
    settlement_next_business_day_beginning_date:
      startDate && dateFilter === FUNDED_TIMESTAMP_FILTER ? startDate : undefined,
    settlement_next_business_day_ending_date:
      endDate && dateFilter === FUNDED_TIMESTAMP_FILTER ? endDate : undefined,
    cardholder_name: cardholderName,
    bank_account_holder_name: bankAccountHolderName,
    bank_account_last_four: bankLastFour,
    credit_card_last_four: cardLastFour,
    payment_sources: paymentSource,
    ...multiSelectParam("payment_channel", "payment_channel", paymentChannel),
    ...multiSelectParam("payment_method", "payment_methods", paymentMethod),
    payment_mode: paymentMode,
    per_page: resultsPerPage,
    ...multiSelectParam("service_type", "service_type", serviceType),
    transaction_number: transactionId,
    account_number: accountNumber,
    slim: true,
  },
  body: null,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
